export default function MerchantNewOrderModal({
  form,
  products,
  inputStyle,
  submittingOrder,
  deliveryFee = 2500,
  setForm,
  onClose,
  onSubmit,
}) {
  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 50, display: 'flex', alignItems: 'flex-end', justifyContent: 'center', background: 'rgba(10,18,40,0.55)', backdropFilter: 'blur(4px)' }} onClick={onClose}>
      <div style={{ background: 'white', borderRadius: '24px 24px 0 0', width: '100%', maxWidth: '520px', maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 -24px 80px rgba(0,0,0,0.25)' }} onClick={(e) => e.stopPropagation()}>
        <div style={{ padding: '16px 0 0', display: 'flex', justifyContent: 'center' }}>
          <div style={{ width: '40px', height: '4px', borderRadius: '2px', background: '#e5e7eb' }} />
        </div>
        <div style={{ padding: '16px 24px 28px' }}>
          <div className="ui-sheet-title" style={{ fontSize: '18px', marginBottom: '20px' }}>Nouvelle commande</div>
          {[
            { key: 'client', label: 'Nom du client', placeholder: 'Aminata Diallo', type: 'text' },
            { key: 'phone', label: 'Téléphone du client', placeholder: '77 000 00 00', type: 'tel' },
            { key: 'address', label: 'Adresse de livraison', placeholder: 'Quartier, Ville', type: 'text' },
          ].map((field) => (
            <div key={field.key} style={{ marginBottom: '12px' }}>
              <label style={{ display: 'block', fontSize: '10px', fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '6px' }}>{field.label}</label>
              <input
                value={form[field.key]}
                onChange={(e) => setForm({ ...form, [field.key]: e.target.value })}
                type={field.type}
                style={inputStyle}
                placeholder={field.placeholder}
                onFocus={(e) => {
                  e.target.style.borderColor = '#173b78';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = '#e2e8f0';
                }}
              />
            </div>
          ))}
          <div style={{ marginBottom: '12px' }}>
            <label style={{ display: 'block', fontSize: '10px', fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '6px' }}>Produit</label>
            <select
              value={form.product_id}
              onChange={(e) => {
                const selected = products.find((product) => String(product.id) === e.target.value);
                setForm((current) => ({
                  ...current,
                  product_id: e.target.value,
                  product_name: selected?.name || '',
                  product_price: selected?.price ?? null,
                  product_stock: selected?.stock ?? null,
                }));
              }}
              style={{ ...inputStyle, background: 'white', cursor: 'pointer' }}
            >
              <option value="">— Sélectionner un produit —</option>
              {products.map((product) => (
                <option key={product.id} value={String(product.id)} disabled={product.stock === 0}>
                  {product.name} — {Number(product.price).toLocaleString('fr-FR')} FCFA
                  {product.stock === 0 ? ' (rupture)' : product.stock !== null ? ` · ${product.stock} en stock` : ''}
                </option>
              ))}
            </select>
            {products.length === 0 && (
              <p style={{ fontSize: '11px', color: '#c53a2d', marginTop: '4px' }}>Aucun produit — ajoutez des produits d'abord.</p>
            )}
          </div>
          <div style={{ marginBottom: '12px' }}>
            <label style={{ display: 'block', fontSize: '10px', fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '6px' }}>Quantité</label>
            <input
              value={form.quantity}
              onChange={(e) => setForm({ ...form, quantity: e.target.value })}
              type="number"
              min="1"
              style={inputStyle}
              placeholder="1"
              onFocus={(e) => {
                e.target.style.borderColor = '#173b78';
              }}
              onBlur={(e) => {
                e.target.style.borderColor = '#e2e8f0';
              }}
            />
            {(() => {
              const qty = Math.max(1, parseInt(form.quantity, 10) || 1);
              if (form.product_stock === null || form.product_stock === undefined) return null;
              if (qty > form.product_stock) {
                return <p style={{ fontSize: '11px', color: '#c53a2d', marginTop: '4px' }}>Stock insuffisant ({form.product_stock} disponible{form.product_stock > 1 ? 's' : ''})</p>;
              }
              return null;
            })()}
          </div>
          {form.product_name && form.quantity && (() => {
            const qty = Math.max(1, parseInt(form.quantity, 10) || 1);
            return (
              <div style={{ background: '#f0fdf4', borderRadius: '10px', padding: '10px 14px', marginBottom: '12px', fontSize: '12px', color: '#15803d', fontWeight: 600, display: 'flex', justifyContent: 'space-between' }}>
                <span>{form.product_name} × {qty}</span>
                <span>{(form.product_price * qty).toLocaleString('fr-FR')} FCFA</span>
              </div>
            );
          })()}
          <div style={{ background: '#f0f4ff', borderRadius: '10px', padding: '10px 14px', marginBottom: '20px', fontSize: '12px', color: '#173b78', fontWeight: 600 }}>
            Frais de livraison : {Number(deliveryFee).toLocaleString('fr-FR')} FCFA
          </div>
          <div style={{ display: 'flex', gap: '10px' }}>
            <button
              onClick={onClose}
              style={{ flex: 1, padding: '12px', borderRadius: '10px', border: '1.5px solid #e2e8f0', background: 'white', fontSize: '13px', color: '#6b7280', cursor: 'pointer', fontWeight: 500 }}
            >
              Annuler
            </button>
            {(() => {
              const qty = Math.max(1, parseInt(form.quantity, 10) || 1);
              const stockInsuffisant =
                form.product_stock !== null &&
                form.product_stock !== undefined &&
                qty > form.product_stock;
              const disabled =
                !form.client || !form.address || !form.product_name || stockInsuffisant || submittingOrder;
              return (
                <button
                  onClick={onSubmit}
                  disabled={disabled}
                  style={{ flex: 2, padding: '12px', borderRadius: '10px', border: 'none', background: disabled ? '#e5e7eb' : 'linear-gradient(135deg, #c53a2d, #8b1e16)', color: disabled ? '#9ca3af' : 'white', fontSize: '13px', fontWeight: 600, cursor: disabled ? 'not-allowed' : 'pointer', boxShadow: disabled ? 'none' : '0 4px 12px rgba(197,58,45,0.3)' }}
                >
                  {submittingOrder ? 'Création…' : 'Créer la commande'}
                </button>
              );
            })()}
          </div>
        </div>
      </div>
    </div>
  );
}
